class MobileDoc extends HTMLElement {
  constructor(){
    super();
    this.dock_cart = this.querySelector('.cart-dock__item');
    this.dock_menu = this.querySelector('.menu-dock__item');
    this.dock_search = this.querySelector('.search-doc__item');

    this.init();
  }

  init(){
    // Cart logic (Speed Cart)
    this.dock_cart?.addEventListener('click', () => {
      document.querySelector('.header__icon--cart')?.click();
    });


    this.dock_search.addEventListener('click', function(){
      document.querySelector('.mobile-dock--popup-search').classList.toggle('hidden');
      document.querySelector('body').classList.add('overflow-hidden-tablet');
    })

    document.querySelector('.close-dock-popup-search').addEventListener('click', function(){
            document.querySelector('.mobile-dock--popup-search').classList.toggle('hidden');
      document.querySelector('body').classList.remove('overflow-hidden-tablet');
    })
  }
}

customElements.define('mobile-doc', MobileDoc);